import * as React from "react";
import { Idevice } from "../../../types/device";

export interface IIndexCompProps {
	label?: string;
	ltp?: any;
	ltpchg?: any;
	ltpchgper?: any;
	device: Idevice;
	classList?: string;
	className?: string;

}

export default function IndexComp(props: IIndexCompProps) {
	// props.device = DeviceContext();
	return (
		<>
		<a href="/market">
			<label className="shareName">{props.label}</label>&nbsp;
			<span className="excLtp">{props.ltp}</span>&nbsp;
			<cite className={props.ltpchg >=0 ? "green":"red"}>
				<span className="excChange"></span>
				{props.ltpchg}&nbsp;&nbsp;
					<span>
						(<span className="excChangeper">{props.ltpchgper}</span>
						%)
					</span>
			</cite>
		</a>
		
	</>
	);
}
